import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const NoExercisesIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 34 36" {...props}>
      <path
        d="M10.1027 11.9073C3.69814 15.7823 2.92672 22.6488 3.34158 25.5976L18.512 9.92266C17.1396 9.7612 15.2716 9.98994 14.5092 10.1245C14.128 9.38447 13.2982 7.79679 13.0291 7.36623C12.6928 6.82803 12.76 6.32347 13.0291 5.81891C13.2444 5.41527 13.7916 5.3592 14.0383 5.38163C15.8771 5.37042 19.7835 5.35472 20.6984 5.38163C21.6134 5.40854 21.887 6.13286 21.9094 6.49166L25.6431 2.5561C24.6475 1.26442 22.7391 0.694835 21.9094 0.571499C19.6108 0.560287 14.7514 0.544589 13.7019 0.571499C12.39 0.605136 9.90087 0.706048 8.45446 3.59886C7.29734 5.9131 7.97233 8.0614 8.45446 8.84627L10.1027 11.9073Z"
        fill="#B8BEC9"
      />
      <path
        d="M33.5479 2.5561L31.5633 0.571499L0.179688 32.9978L2.23156 34.8479L5.56165 31.6187C7.0417 34.3904 9.38509 35.0385 10.3718 35.0161H24.5667C26.4504 35.0161 28.0986 33.5024 29.7805 30.7441C31.4624 27.9859 32.2697 24.084 30.6887 19.2402C29.424 15.3652 26.2598 12.737 24.8358 11.9073C24.8627 11.6113 24.9816 11.4476 25.0376 11.4027L33.5479 2.5561Z"
        fill="#B8BEC9"
      />
    </SvgIcon>
  );
};

export default NoExercisesIcon;
